const ROUTE_KEYS = [
    'FORMATION_CONTINUE',
    'FORMATION_INITIALE',
    'FORMATION_ENTRY',
    'DROIT_IMAGE_FORM',
    'DROIT_IMAGE_PREVIEW',
    'DROIT_IMAGE_ENTRIES',
    'FORMATION_ENTRIES',
    'FICHE_INSCRIPTION',
    'FICHE_RENSEIGNEMENT',
    'FICHE_RENSEIGNEMENT_ENTRIES',
    'FICHE_RENSEIGNEMENT_PREVIEW',
    'FICHE_RENSEIGNEMENT_SUCCESS',
    'FICHE_INSCRIPTION_PREVIEW',
    'FICHE_INSCRIPTION_ENTRIES',
    'INSCRIPTION_SUCCESS',
    'FORMATION_INITIALE_SUCCESS',
] as const;

export { ROUTE_KEYS };
